// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip .ns-filter-tooltip{background-color:var(--body-bg);margin:-6px;padding:6px}.tooltip .ns-filter-tooltip .ns-filter-tooltip-item>div{background-color:rgba(0,0,0,.05);border:1px solid var(--header-border);border-radius:5px;color:var(--tag-text);display:inline-block;line-height:20px;padding:2px 5px;white-space:nowrap;margin:4px 0}", ""]);
// Exports
module.exports = exports;
